import { render, staticRenderFns } from "./ExerciseCategoryList.vue?vue&type=template&id=3968ad4e&"
import script from "./ExerciseCategoryList.vue?vue&type=script&lang=js&"
export * from "./ExerciseCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports